export const locations = [
  {
    key: 'atx',
    title: 'Diamonds Direct Austin',
    name: 'Austin, TX',
    email: 'infoAUS@diamondsdirect.com',
    phone: '5126919950',
    address1: '11104 Domain Drive',
    address2: 'Austin, TX 78758',
    number: 5,
  },
  {
    key: 'bhm',
    title: 'Diamonds Direct Birmingham',
    name: 'Birmingham, AL',
    email: 'infoBHM@diamondsdirect.com',
    phone: '2052017400',
    address1: '2800 Cahaba Village Plz.',
    address2: 'Birmingham, AL 35243',
    number: 3,
  },
  {
    key: 'boc',
    title: 'Diamonds Direct Boca Raton',
    name: 'Boca Raton, FL',
    email: 'infoBOCA@diamondsdirect.com',
    phone: '5614142091',
    address1: '21078 St. Andrews Blvd',
    address2: 'Boca Raton, Florida 33433',
    number: 21,
  },
  {
    key: 'chs',
    title: 'Diamonds Direct Charleston',
    name: 'Charleston, SC',
    email: 'infoCHS@diamondsdirect.com',
    phone: '8436062558',
    address1: '1911 Highway 17N',
    address2: 'Mt. Pleasant, SC 29464',
    number: 7,
  },
  {
    key: 'clt',
    title: 'Diamonds Direct Charlotte',
    name: 'Charlotte, NC',
    email: 'infoCLT@diamondsdirect.com',
    phone: '7045329041',
    address1: '4521 Sharon Road',
    address2: 'Charlotte, NC 28211',
    number: 1,
  },
  {
    key: 'cle',
    title: 'Diamonds Direct Cleveland',
    name: 'Cleveland, OH',
    email: 'infoCLE@diamondsdirect.com',
    phone: '2162732812',
    address1: '2101 Richmond Rd.',
    address2: 'Beachwood, OH 44122',
    number: 17,
  },
  {
    key: 'coh',
    title: 'Diamonds Direct Columbus',
    name: 'Columbus, OH',
    email: 'infocol@diamondsdirect.com',
    phone: '6145160515',
    address1: '1330 Polaris Pkwy',
    address2: 'Columbus, OH 43240',
    number: 16,
  },
  {
    key: 'dfw',
    title: 'Diamonds Direct Dallas',
    name: 'Dallas, TX',
    email: 'infoDTX@diamondsdirect.com',
    phone: '9723426663',
    address1: '8127 Preston Rd.',
    address2: 'Dallas, TX 75225',
    number: 11,
  },
  {
    key: 'ftx',
    title: 'Diamonds Direct Frisco',
    name: 'Frisco, TX',
    email: 'infoFRISCO@diamondsdirect.com',
    phone: '4698504270',
    address1: '8440 State Hwy 121, Bldg A',
    address2: 'Frisco, TX 75034',
    number: 18,
  },
  {
    key: 'gsc',
    title: 'Diamonds Direct Greenville',
    name: 'Greenville, SC',
    email: 'infoGVL@diamondsdirect.com',
    phone: '8645015090',
    address1: '8440 State Hwy 121, Bldg A',
    address2: 'Greenville, SC. 29607',
    number: 22,
  },
  {
    key: 'bay',
    title: 'Diamonds Direct Houston (Baybrook)',
    name: 'Baybrook, TX',
    email: 'infoBAY@diamondsdirect.com',
    phone: '2816123632',
    address1: '8610 Gulf Frwy',
    address2: 'Friendswood, TX 77546',
    number: 25,
  },
  {
    key: 'hou',
    title: 'Diamonds Direct Houston (Galleria)',
    name: 'Houston, TX',
    email: 'infoHOU@diamondsdirect.com',
    phone: '3462502054',
    address1: '3115 West Loop S.',
    address2: 'Houston, TX 77027',
    number: 23,
  },
  {
    key: 'ind',
    title: 'Diamonds Direct Indianapolis',
    name: 'Indianapolis, IN',
    email: 'infoindy@diamondsdirect.com',
    phone: '3175758555',
    address1: '8557 North River Road',
    address2: 'Indianapolis, IN 46240',
    number: 12,
  },
  {
    key: 'jax',
    title: 'Diamonds Direct Jacksonville',
    name: 'Jacksonville, FL',
    email: 'infojax@diamondsdirect.com',
    phone: '9045155959',
    address1: '4840 Town Center Parkway',
    address2: 'Jacksonville, FL 32246',
    number: 14,
  },
  {
    key: 'kcy',
    title: 'Diamonds Direct Kansas City',
    name: 'Kansas City, KS',
    email: 'infoKSC@diamondsdirect.com',
    phone: '9133121660',
    address1: '4500 W 119th Street',
    address2: 'Leawood, KS 66209',
    number: 19,
  },
  {
    key: 'nol',
    title: 'Diamonds Direct New Orleans',
    name: 'New Orleans, LA',
    email: 'infoNOLA@diamondsdirect.com',
    phone: '5043833900',
    address1: '3230 Severn Ave',
    address2: 'Metairie, LA 70002',
    number: 20,
  },
  {
    key: 'nva',
    title: 'Diamonds Direct Tysons',
    name: 'Tysons, LA',
    email: 'infoTYS@diamondsdirect.com',
    phone: '5713076220',
    address1: '8113 Leesburg Pike',
    address2: 'Vienna, VA 22182',
    number: 26,
  },
  {
    key: 'pit',
    title: 'Diamonds Direct Pittsburgh',
    name: 'Pittsburgh, PA',
    email: 'infoPITT@diamondsdirect.com',
    phone: '4128379070',
    address1: '5004 McKnight Rd.',
    address2: 'Pittsburgh, PA 15237',
    number: 24,
  },
  {
    key: 'okc',
    title: 'Diamonds Direct Oklahoma City',
    name: 'Oklahoma City, OK',
    email: 'infoOKC@diamondsdirect.com',
    phone: '4056088802',
    address1: '5521 North Pennsylvania Ave',
    address2: 'Oklahoma City, OK 73112',
    number: 8,
  },
  {
    key: 'ral',
    title: 'Diamonds Direct Raleigh',
    name: 'Raleigh, NC',
    email: 'infoRal@diamondsdirect.com',
    phone: '9195712881',
    address1: '4401 Glenwood Avenue',
    address2: 'Raleigh, NC 27612',
    number: 4,
  },
  {
    key: 'rva',
    title: 'Diamonds Direct Richmond',
    name: 'Richmond, VA',
    email: 'infoRic@diamondsdirect.com',
    phone: '8049670500',
    address1: '11131 West Broad Street',
    address2: 'Glen Allen, VA 23060',
    number: 6,
  },
  {
    key: 'stl',
    title: 'Diamonds Direct St. Louis',
    name: 'St. Louis, MO',
    email: 'infostl@diamondsdirect.com',
    phone: '3149423777',
    address1: '11619 Olive Blvd',
    address2: 'Saint Louis, MO 63141',
    number: 13,
  },
  {
    key: 'san',
    title: 'Diamonds Direct San Antonio',
    name: 'San Antonio, TX',
    email: 'infoSAT@diamondsdirect.com',
    phone: '2102479197',
    address1: '15900 La Cantera Pky, Bldg 18',
    address2: 'San Antonio, TX 78256',
    number: 10,
  },
  {
    key: 'vab',
    title: 'Diamonds Direct Virginia Beach',
    name: 'Virginia Beach, VA',
    email: 'infoVAB@diamondsdirect.com',
    phone: '7578370288',
    address1: '4452 Virginia Beach Blvd',
    address2: 'Virginia Beach, VA 23462',
    number: 9,
  },
  {
    key: 'try',
    title: 'Diamonds Direct Troy',
    name: 'Troy, MI',
    email: 'infoTROY@diamondsdirect.com',
    phone: '2485095435',
    address1: '1985 West Big Beaver Rd. Ste 100',
    address2: 'Troy, MI 48084',
    number: 27,
  },
];



// WEBPACK FOOTER //
// ./src/constants/locations.jsx